import React from 'react';

const RadioButton = ({ ariaLabel, ariaControls, id, isChecked, label, name, onClick, onKeyDown, value }) => {
    const internalKeyDown = e => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            onKeyDown();
        }
    };

    return (
        <label
            htmlFor={id}
            tabIndex={0}
            onClick={onClick}
            onKeyDown={e => internalKeyDown(e, value)}
            className={isChecked ? 'clx-step__button-radio selected' : 'clx-step__button-radio'}
        >
            <input
                aria-label={ariaLabel}
                aria-controls={ariaControls}
                defaultChecked={isChecked}
                id={id}
                name={name}
                tabIndex={-1}
                type="radio"
                value={value}
            />
            <span className='clx-step__form-label'>
                {label}
            </span>
        </label>
    );
};

export default RadioButton;
